import useRequest from '@/websdk/utils/request';

export default (function () {
  // console.error('GET==>', isContinue)
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/address/position',
    name: 'addressPositonGet',
    method: 'GET'
  });
  //console.error('GET==>', JSON.stringify(data))
  return [isRequestSuccessed, data || [], exec];
  // }
})